import { NgModule } from '@angular/core';
import { FiInputAutoWidthDirective } from './fi-input-auto-width.directive';

@NgModule({
    declarations: [FiInputAutoWidthDirective],
    exports: [FiInputAutoWidthDirective],
})
export class FiInputAutoWidthModule {}
